module.exports = __webpack_public_path__ + "static/media/beyond-the-fantastic-various.1b915040.jpg";